import { render, staticRenderFns } from "./sticky-header.vue?vue&type=template&id=5fff8815&scoped=true"
import script from "./sticky-header.vue?vue&type=script&lang=js"
export * from "./sticky-header.vue?vue&type=script&lang=js"
import style0 from "./sticky-header.vue?vue&type=style&index=0&id=5fff8815&prod&lang=css"
import style1 from "./sticky-header.vue?vue&type=style&index=1&id=5fff8815&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fff8815",
  null
  
)

export default component.exports